import React from "react";

const ConsultancyHero: React.FC = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center px-3 w-full">
        <div className="text-center text-white text-2xl md:text-3xl pt-5 w-full max-w-4xl lg:text-4xl font-light xl:text-[3.4rem] xl:space-y-7">
          <h3 className="">Dream Weavers Recruitment &</h3>
          <h3>Staffing Consultancy</h3>
        </div>
        <p className="pt-4 xl:pt-10 text-sm text-center max-w-xl xl:text-[25.5px] font-light text-[#FF7E00]">
          Your Trusted Partner for Skilled Talent Solutions
        </p>
        <p className="pt-4 xl:pt-8 text-sm xl:text-base text-center max-w-4xl font-light text-white">
          We go beyond traditional recruitment services to create meaningful
          connections between talented professionals and forward-thinking
          organizations. With a legacy of excellence, we specialize in sourcing,
          training, and placing the right talent for all your business needs,
          making us one of India's top manpower consulting firms.
        </p>
      </div>
      <div className="flex justify-center items-center pt-[5rem] xl:pt-[5.5rem] -mb-[8rem] md:pt-10 md:-mb-[13rem] xl:-mb-[27rem]">
        <div className="max-w-lg md:max-w-2xl xl:h-[637px] xl:max-w-[90rem]">
          <iframe
            title="YouTube video player"
            src="https://www.youtube.com/embed/mTzCzUeYxug?si=QNdeu5HvOyht-9hC"
            className="max-w-lg md:max-w-2xl h-[12rem] sm:h-[19rem] rounded-xl lg:rounded-3xl md:w-[34rem] lg:h-[28rem] sm:w-[29rem] lg:max-w-4xl xl:h-[32rem] lg:w-[90rem]"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ConsultancyHero;
